"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const bars_1 = require("./bars");
/**Una barra de navegación, enciere en un div con márgenes negativos para ajustar a la página */
class NavBar extends React.Component {
    constructor(props) {
        super(props);
        this.handleResize = () => {
            this.setState({ collapsed: (document.documentElement.clientWidth < (this.props.collapsedWidth || 768)) });
        };
        this.state = { collapsed: false };
    }
    componentWillMount() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }
    render() {
        return React.createElement(bars_1.NavBarContainer, Object.assign({}, Object.assign({}, this.props, { height: this.props.height || 36 }), { collapsed: this.state.collapsed }));
    }
}
exports.NavBar = NavBar;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/navbar/navbar.js
// module id = 2244
// module chunks = 0